<app-auth></app-auth>
<app-menu></app-menu>

<div class="container">
    <div class="page-header">
        <h2>Application Forms</h2>
        <app-button-primary text="New Form" (click)="openNewFormModal()"></app-button-primary>
    </div>

    <div class="forms-list" *ngIf="loaded">
        <div *ngIf="forms.length === 0" class="empty-state">
            <p>No certification forms found. Create your first form to get started.</p>
        </div>

        <div class="form-item" *ngFor="let form of forms">
            <div class="form-info">
                <h3 class="form-name">{{ form.name }}</h3>
                <p class="form-description" *ngIf="form.description">{{ form.description }}</p>
                <div class="form-meta">
                    <span class="version">Version {{ form.currentVersion }}</span>
                    <span class="status" [class.active]="form.active" [class.inactive]="!form.active">
                        {{ form.active ? 'Active' : 'Inactive' }}
                    </span>
                </div>
            </div>
            <div class="form-actions">
                <app-button-secondary [isText]="true" buttonText="Edit" (click)="editForm(form)"></app-button-secondary>
                <app-button-secondary [isText]="true" buttonText="Rename" (click)="openEditModal(form)"></app-button-secondary>
                <app-button-secondary [isText]="true" buttonText="Deactivate" (click)="confirmDelete(form)" *ngIf="form.active"></app-button-secondary>
            </div>
        </div>
    </div>
</div>

<!-- New Form Modal -->
<div class="modal-overlay" *ngIf="showNewFormModal" (click)="showNewFormModal = false">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <h3>Create New Certification Form</h3>
        <div class="field">
            <label>Form Name *</label>
            <input type="text" [(ngModel)]="newFormName" placeholder="e.g. Responsible Returns Certification" />
        </div>
        <div class="field">
            <label>Description</label>
            <textarea [(ngModel)]="newFormDescription" placeholder="Optional description"></textarea>
        </div>
        <div class="modal-actions">
            <app-button-primary text="Create Form" [isActive]="!!newFormName.trim() && !creating" (click)="createForm()"></app-button-primary>
            <app-button-secondary [isText]="true" buttonText="Cancel" (click)="showNewFormModal = false"></app-button-secondary>
        </div>
    </div>
</div>

<!-- Edit Name/Description Modal -->
<div class="modal-overlay" *ngIf="showEditModal" (click)="cancelEdit()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <h3>Edit Form Details</h3>
        <div class="field">
            <label>Form Name *</label>
            <input type="text" [(ngModel)]="editName" placeholder="Form name" />
        </div>
        <div class="field">
            <label>Description</label>
            <textarea [(ngModel)]="editDescription" placeholder="Optional description"></textarea>
        </div>
        <div class="modal-actions">
            <app-button-primary text="Save" [isActive]="!!editName.trim() && !saving" (click)="saveEdit()"></app-button-primary>
            <app-button-secondary [isText]="true" buttonText="Cancel" (click)="cancelEdit()"></app-button-secondary>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="modal-overlay" *ngIf="showDeleteModal" (click)="cancelDelete()">
    <div class="modal-content" (click)="$event.stopPropagation()">
        <h3>Deactivate Form</h3>
        <p>Are you sure you want to deactivate <strong>{{ deleteTarget?.name }}</strong>? This form will no longer be available for new applications.</p>
        <div class="modal-actions">
            <app-button-primary text="Deactivate" (click)="deleteForm()"></app-button-primary>
            <app-button-secondary [isText]="true" buttonText="Cancel" (click)="cancelDelete()"></app-button-secondary>
        </div>
    </div>
</div>
